<template>
    <div>
        <ul
            class="catalogue_page mt20 current_page"
            :class="{ cursor_pointer: !catalogue.length }"
            @click="handleEmpty"
        >
            {{ catalogue.length > 0 ? '' : '--' }}
            <li
                v-for="(item, index) in catalogue"
                :key="index"
                @click="handleClick(item)"
                class="catalogue_item PingFangMedium"
                :class="{
                    current: activeName == item.local_id,
                    teach: articleType == 'exercise',
                    work: articleType == 'courseware',
                    temp: articleType == 'template',
                    catalogue_level_1: item.level == 1,
                    catalogue_level_2: item.level == 2,
                    catalogue_level_3: item.level == 3,
                }"
            >
                {{ item.name ? item.name : '--' }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    props: {
        catalogue: {
            // 目录数据
            type: Array,
            default: () => [],
        },
        articleType: {
            //
            type: String,
            default: 'exercise',
        },
        isStudyed: {
            // 是否已购买
            type: Boolean,
            default: false,
        },
        activeName: {
            type: String,
            default: 'title-1-0',
        },
    },
    methods: {
        //这里传入的tab相当于item
        handleClick(tab) {
            this.$emit('handleClick', tab)
        },

        // 没有h标签时，点击emit空事件
        handleEmpty() {
            if (this.catalogue.length <= 0) {
                this.$emit('handle-empty')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.catalogue_page {
    box-sizing: border-box;
    border-radius: 4px;

    .catalogue_item {
        box-sizing: border-box;
        padding: 9px 12px;
        overflow: hidden;
        font-size: 16px;
        line-height: 22px;
        color: #626262;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-radius: 2px;
        cursor: pointer;
    }
    .catalogue_level_1 {
        font-family: 'PingFang SC';
        font-style: normal;
        font-size: 16px;
        line-height: 22px;
        color: #3a3a3a;
    }
    .catalogue_level_2,
    .catalogue_level_3 {
        display: flex;
        align-items: center;
        padding-left: 20px;
        font-size: 14px;
        line-height: 20px;
        &::before {
            display: inline-block;
            width: 6px;
            height: 6px;
            margin-right: 10px;
            background: #b4b4bb;
            border-radius: 50%;
            content: ' ';
        }
    }
    .catalogue_level_3 {
        padding-left: 40px;
    }
    .catalogue_icon {
        margin-right: 3px;
        color: #c4c4c4;
    }
    .current {
        color: #fff;
        background: linear-gradient(90deg, #65CB50 0%, #326A54 100%);
        &::before {
            background: #fff;
        }
        .catalogue_icon {
            color: #fff;
        }
    }
}
</style>
